import {
  I18nextProvider
} from "../chunk-6N4NEKWU.mjs";
import "../chunk-D57E6H3M.mjs";

// src/i18n/ComponentsI18nProvider.tsx
import { useLayoutEffect } from "react";
import { componentsI18n, loadComponentsLocale, normalizeLocale } from "./instance.mjs";
import { jsx } from "react/jsx-runtime";
function ComponentsI18nProvider({ locale, children }) {
  const resolved = locale != null ? normalizeLocale(locale) : null;
  useLayoutEffect(() => {
    if (resolved != null) {
      void loadComponentsLocale(resolved);
    }
  }, [resolved]);
  return /* @__PURE__ */ jsx(I18nextProvider, { i18n: componentsI18n, children });
}
ComponentsI18nProvider.displayName = "ComponentsI18nProvider";
export {
  ComponentsI18nProvider
};
//# sourceMappingURL=ComponentsI18nProvider.mjs.map